/**
 * RESPONSIBILITY: draw the thing an event wants a visitor to do.
 *
 * Centred and alone, because a button competing with a column of prose is a button
 * nobody presses. The words on it are the editor's: "Register" and "Sign up" and "RSVP"
 * mean different things to the person deciding whether this is for them.
 */
import { Html } from '@framework/react';
import { THEME } from '@app/sections';
import { Band } from './Band';
import type { BandProps } from './kind';

export function Cta({ s }: BandProps) {
  if (!s.ctaLabel && !s.heading) return null;

  return (
    <Band theme={THEME.Cta} heading={s.heading}>
      {s.bodyHtml ? <Html className="md-body ev-prose">{s.bodyHtml}</Html> : null}
      {s.ctaLabel ? (
        <p className="ev-btns">
          <a className="btn" href={s.ctaHref || '#'}>{s.ctaLabel}</a>
        </p>
      ) : null}
    </Band>
  );
}
